import { Trans } from "@lingui/react";
import { useResolvedCompanyCtx } from '@contexts/ResolvedCompanyContext/ResolvedCompanyProvider';
import { useLayoutIsXS } from '@segments/Responsive/client';
import * as React from 'react';
import { Grid } from '~ui/components/layout/Box';
import { H1 } from '~ui/components/typography/Heading/Heading';
import { Text } from '~ui/components/typography/Text/Text';
import { letterSpacingValues } from '~ui/styleGuide/fontStyles';
import { breakpoints } from '~ui/styleGuide/styles';
import { LogoBox } from './LogoBox';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var headingSizes = {
  minSize: 24,
  maxSize: 42
};
var descriptionSizes = {
  minSize: 16,
  maxSize: 18
};
/**
 * Hero section of the company page.
 * Contains the company logo, name & description.
 */

export var CompanyHero = function CompanyHero(_ref) {
  var logoSize = _ref.logoSize,
      gridGap = _ref.gridGap,
      _ref$hasDescription = _ref.hasDescription,
      hasDescription = _ref$hasDescription === void 0 ? false : _ref$hasDescription;
  var isMobile = useLayoutIsXS();

  var _useResolvedCompanyCt = useResolvedCompanyCtx(),
      resolvedBranch = _useResolvedCompanyCt.resolvedBranch;

  var logoTextGap = isMobile ? "large" : "medium";
  return /*#__PURE__*/_jsxs(Grid, {
    justifyItems: "center",
    gap: gridGap || logoTextGap,
    padding: {
      vertical: "none",
      horizontal: "medium"
    },
    children: [/*#__PURE__*/_jsx(LogoBox, {
      logoSize: logoSize
    }), /*#__PURE__*/_jsxs(Grid, {
      justifyItems: "center",
      gap: "smallMedium",
      children: [/*#__PURE__*/_jsx(H1, {
        textAlign: "center",
        letterSpacing: letterSpacingValues.tighter,
        fontStyle: isMobile ? "bold" : "boldExtra",
        responsiveSize: {
          maxBreakpoint: breakpoints.lg,
          minBreakpoint: breakpoints.sm,
          maxSize: headingSizes.maxSize,
          minSize: headingSizes.minSize
        },
        children: resolvedBranch.name
      }), hasDescription && /*#__PURE__*/_jsx(Text, {
        lineHeight: "1.5",
        textAlign: "center",
        textShadow: "medium",
        fontStyle: isMobile ? "medium" : "regular",
        responsiveSize: {
          maxBreakpoint: breakpoints.lg,
          minBreakpoint: breakpoints.sm,
          maxSize: descriptionSizes.maxSize,
          minSize: descriptionSizes.minSize
        },
        children: /*#__PURE__*/_jsx(Trans, {
          id: "bLAX95"
        })
      })]
    })]
  });
};